<template>
  <div class="c-loading" :class="{ 'c-loading--visible': visible }">
    <div class="c-loading__inner">
      <o-icon class="c-loading__icon" icon="spinner" size="large" />
      <div class="c-loading__label"><slot /></div>
    </div>
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OLoading',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-loading {
  background: rgba(#000, 0.4);
  bottom: 0;
  display: flex;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.1s linear;
  z-index: 10;
}

.c-loading__inner {
  align-items: center;
  background: #fff;
  border-radius: 1.2rem;
  box-shadow: $box-shadow-large;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 2.4rem;
  width: 28rem;
}

@keyframes spinLoader {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(720deg);
  }
}

.c-loading__icon {
  animation: spinLoader 1s cubic-bezier(0.33, 0.155, 0.62, 0.83) 0s infinite
    both;
  color: $primary-color;
  color: var(--primary-color);
  margin-bottom: 1.6rem;
}

.c-loading__label {
  line-height: 2.4rem;
  text-align: center;
}

.c-loading--visible {
  opacity: 1;
  pointer-events: auto;
}
</style>
